<!-- subdidy-details.component.html -->

<p-toast></p-toast>

<div class="card dashboardTable">
  <p-table
    #miSurvey
    [value]="micada1Data"
    [rows]="10"
    [paginator]="true"
    responsiveLayout="scroll"
    [rowHover]="true"
    dataKey="TAN_No"
    currentPageReportTemplate="{{ 'SHOWING' | translate }} {first} {{ 'TO' | translate }} {last} {{ 'OF' | translate }} {totalRecords} {{ 'ENTRIES' | translate }}"
    [showCurrentPageReport]="true"
    [loading]="loading"
    class="p-datatable-gridlines"
    [tableStyle]="{ 'max-width': '80rem' }"
    (onFilter)="onTableFilter($event)"
  >
    <!-- Caption with Search and Download -->
    <ng-template pTemplate="caption">
      <div class="p-grid p-align-center p-justify-between">
        <div class="p-col-12 p-md-6">
          <h5 class="m-0 table-header-text" [ngStyle]="{ color: 'black' }">
            {{ tableHeaderName | translate }}
          </h5>
        </div>
        <div class="p-col-12 p-md-6 p-d-flex p-jc-end p-ai-center gap-3">
          <!-- Search Input with Event Handler -->
          <span class="p-input-icon-left">
            <i class="pi pi-search"></i>
            <input
              pInputText
              type="text"
              placeholder="{{ 'SEARCH' | translate }}"
              (input)="onSearchInput($event)"
            />
          </span>
          <!-- Download Button with Popup Menu -->
          <button
            type="button"
            pButton
            pRipple
            icon="pi pi-download"
            class="p-button-help"
            (click)="menu.toggle($event)"
            aria-haspopup="true"
            aria-controls="miCompletedReportMenu"
          ></button>
          <p-menu #menu id="miCompletedReportMenu" [popup]="true" [model]="miCompletedReport"></p-menu>
        </div>
      </div>
    </ng-template>

    <!-- Table Headers -->
    <ng-template pTemplate="header">
      <tr>
        <th pSortableColumn="AppID">{{ 'AppID' | translate }}
          <p-sortIcon field="AppID"></p-sortIcon>
        </th>
        <th pSortableColumn="Program_Name">{{ 'Program_Name' | translate }}
          <p-sortIcon field="Program_Name"></p-sortIcon>
        </th>
        <th pSortableColumn="Amt">{{ 'Amount' | translate }}
          <p-sortIcon field="Amt"></p-sortIcon>
        </th>
        <th pSortableColumn="FarmerName">{{ 'FarmerName' | translate }}
          <p-sortIcon field="FarmerName"></p-sortIcon>
        </th>
        <th pSortableColumn="VendorName">{{ 'VendorName' | translate }}
          <p-sortIcon field="VendorName"></p-sortIcon>
        </th>
        <th pSortableColumn="District">{{ 'District' | translate }}
          <p-sortIcon field="District"></p-sortIcon>
        </th>
        <th pSortableColumn="Block">{{ 'Block' | translate }}
          <p-sortIcon field="Block"></p-sortIcon>
        </th>
        <th pSortableColumn="Village">{{ 'Village' | translate }}
          <p-sortIcon field="Village"></p-sortIcon>
        </th>
        <th pSortableColumn="PlantSpacing">{{ 'PlantSpacing' | translate }}
          <p-sortIcon field="PlantSpacing"></p-sortIcon>
        </th>
        <th pSortableColumn="RowSpacing">{{ 'RowSpacing' | translate }}
          <p-sortIcon field="RowSpacing"></p-sortIcon>
        </th>
        <th pSortableColumn="MIArea">{{ 'MIArea' | translate }}
          <p-sortIcon field="MIArea"></p-sortIcon>
        </th>
      </tr>
    </ng-template>

    <!-- Table Body -->
    <ng-template pTemplate="body" let-consolidateData>
      <tr class="body-section">
        <td>{{ consolidateData?.AppID }}</td>
        <td>{{ consolidateData?.Program_Name }}</td>
        <td>{{ consolidateData?.Amt | currency }}</td>
        <td>{{ consolidateData?.FarmerName }}</td>
        <td>{{ consolidateData?.VendorName }}</td>
        <td>{{ consolidateData?.District }}</td>
        <td>{{ consolidateData?.Block }}</td>
        <td>{{ consolidateData?.Village }}</td>
        <td>{{ consolidateData?.PlantSpacing }}</td>
        <td>{{ consolidateData?.RowSpacing }}</td>
        <td>{{ consolidateData?.MIArea }}</td>
      </tr>
    </ng-template>

    <!-- Optional Table Footer -->
    <ng-template pTemplate="footer">
      <!-- You can add footer content here if needed -->
    </ng-template>
  </p-table>
</div>
